import "antd/dist/reset.css";
import React from "react";
import { GlobalStyle, theme } from "../styled";
import { Helmet } from "react-helmet";
import { Navigation } from "./Navigation";
import { Script, graphql, useStaticQuery } from "gatsby";
import { ThemeProvider } from "styled-components";

type LayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
      }
    `
  );

  const { title, siteUrl } = data.site.siteMetadata;

  return (
    <ThemeProvider theme={theme}>
      <Helmet titleTemplate={`%s - ${title}`} defaultTitle={title}>
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@imbue_ai" />
        <meta property="og:title" content={title} />
        <meta property="og:image" content={siteUrl + "/logo.png"} />
      </Helmet>
      <GlobalStyle />
      <Navigation />
      <Script id="rb2b">
        {`!function () {var reb2b = window.reb2b = window.reb2b || []; if (reb2b.invoked) return;reb2b.invoked = true;reb2b.methods = ["identify", "collect"]; reb2b.factory = function (method) {return function () {var args = Array.prototype.slice.call(arguments); args.unshift(method);reb2b.push(args);return reb2b;};}; for (var i = 0; i < reb2b.methods.length; i++) {var key = reb2b.methods[i];reb2b[key] = reb2b.factory(key);} reb2b.load = function (key) {var script = document.createElement("script");script.type = "text/javascript";script.async = true; script.src = "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/" + key + "/QOQRJHD98Z62.js.gz"; var first = document.getElementsByTagName("script")[0]; first.parentNode.insertBefore(script, first);}; reb2b.SNIPPET_VERSION = "1.0.1";reb2b.load("QOQRJHD98Z62");}();`}
      </Script>
      {children}
    </ThemeProvider>
  );
}
